// extracted by mini-css-extract-plugin
export default {"small":"OfferItem_small__LXdaz","check":"OfferItem_check__IAiZk","placeHolderShimmer":"OfferItem_placeHolderShimmer__zegM0"};